import { Pipe, PipeTransform } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { cf_window } from '../../config';
import { CfContextService } from '../context';

@Pipe({
  name: 'assetsPipe',
  pure: true,
})
export class AssetsPipe implements PipeTransform {
  constructor(private locationStrategy: LocationStrategy, private router: Router, private contextService: CfContextService) {}

  /**
   * Creates the assets path
   * @param path Provided path
   */
  public transform(path: string | null): string {
    if (!path) {
      return '';
    }
    const foundConfig = this.router.config.find((cfg) => {
      const cfgUrl = `/(${cfg.outlet}:${cfg.path}/`;
      return this.router.url.includes(cfgUrl);
    });
    let baseHref = this.locationStrategy.getBaseHref();
    if (foundConfig && foundConfig.data) {
      baseHref = (window as cf_window)._cf_fe20_config_.localDeployUrl.concat(foundConfig.data['appName']);
    }
    if (!baseHref.endsWith('/')) {
      baseHref = baseHref.concat('/');
    }
    if (path.startsWith(this.contextService.context)) {
      return path;
    }
    const isBGImage = path.includes('url') && path.includes('(') && path.includes(')');
    if (isBGImage) {
      return path.slice(0, 5).concat(baseHref).concat(path.slice(5, path.length));
    }
    const sanitizedPath = path.replace(/^(\.\/)?/gi, '');
    return baseHref.concat(sanitizedPath);
  }
}
